export default "__VITE_ASSET__P6Hw9vSK__"